<template>
  <v-modal
    id="show-case-duplicate-modal"
    class-name="modal-fullscreen-sm-down w-auto"
    size="lg"
    @closed="emit('closed')"
  >
    <modal-header>
      <modal-title>{{ $t("tourClient.copyCase") }}</modal-title>
    </modal-header>

    <modal-body>
      <div>{{ $t("tourClient.copyCase") }} content</div>
    </modal-body>
    <modal-footer class="d-flex justify-content-between mt-4 px-20">
      <v-button class="btn-sm btn-primary">Cancle</v-button>
      <v-button class="btn-sm btn-success" @click="copyCase"> {{ $t("tourClient.copyCase") }} </v-button>
    </modal-footer>
  </v-modal>
</template>

<script setup name="TheCaseDuplicateModal">
import VModal from "@/components/vendor/basic/modal/VModal.vue";
import ModalHeader from "@/components/vendor/basic/modal/ModalHeader.vue";
import ModalTitle from "@/components/vendor/basic/modal/ModalTitle.vue";
import ModalBody from "@/components/vendor/basic/modal/ModalBody.vue";
import ModalFooter from "@/components/vendor/basic/modal/ModalFooter.vue";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import api from "@/api";
import { useToast } from "vue-toastification";

const toast = useToast();
const emit = defineEmits(["closed", "loadClientCases"]);
const props = defineProps({
  caseId: {
    type: String,
    required: true,
  },
  agency: {
    type: String,
    required: true,
  },
});

const copyCase = async () => {
  try {
    const response = await api.case.caseCopy(props.agency, Number(props.caseId));

    if (response) {
      toast.success(response.message);
      emit("loadClientCases");
      emit("closed");
    }
  } catch (e) {
    console.error(e);
    toast.error(e?.response?.data?.message || "Something went wrong");
  } 
};
</script>
